import React from 'react';

const Spinner = ({ color }: { color: string }) => (
  <div className="spin-animation" data-testid="spinner">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-152.000000, -331.000000)">
          <g
            id="spinner"
            transform="translate(176.473248, 354.848048) rotate(-58.000000) translate(-176.473248, -354.848048) translate(153.473248, 331.848048)"
          >
            {/* this outer circle prevents wobble by making aspect ration 1:1.
              important! make sure strokeWidth=0 as sketch will not export correctly */}
            <circle id="border" stroke="#000" strokeWidth="0" cx="23" cy="23" r="23" />
            <path
              d="M34.995052,10.0724539 C31.7933403,6.96111516 27.423722,5.04523172 22.606625,5.04523172 C12.7882295,5.04523172 4.82884724,13.0046139 4.82884724,22.8230095 C4.82884724,32.641405 12.7882295,40.6007873 22.606625,40.6007873 C31.5778451,40.6007873 38.9970196,33.9556901 40.2105484,25.3190959"
              id="Combined-Shape"
              stroke={color}
              transform="translate(22.519698, 22.823009) rotate(-6.000000) translate(-22.519698, -22.823009) "
            />
            <path
              d="M36.7706946,15.2108452 L32.1730894,16.1598019 L32.176458,14.7319964 L36.7519077,12.6835249 C36.8124601,8.34371066 37.8079067,7.16789496 38.2671804,9.39924696 C38.4143914,10.1144622 38.5065163,11.179728 38.4951112,12.6030522 L43.0940989,14.4004287 L43.0905952,15.8281562 L38.4725875,15.1067102 L38.4323913,18.1151765 L39.9161102,19.7156866 L39.8970366,20.7913978 L37.5745796,19.2216535 L35.1698605,20.9224156 L35.1890156,19.8465631 L36.7550503,18.1767863 L36.8114622,15.2351358 L36.7706946,15.2108452 Z"
              id="plane"
              fill={color}
              transform="translate(37.633594, 14.608494) rotate(148.000000) translate(-37.633594, -14.608494) "
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default Spinner;
